import * as Yup from "yup";
import { FilterSetting } from "reducers/settings/types";
import { FilterType } from "constants/filters";

export interface PenRangeFilter extends FilterSetting {
  type: FilterType.PenRange;
  startPenId: string | null;
  endPenId: string | null;
  roundId: number | null;
}

export interface PenRangeFormValues {
  startPenId: string | null;
  startPenData: null;
  endPenId: string | null;
  endPenData: null;
  roundId: number | null;
}

export function getPenRangeFilterFormData(
  id: string,
  values: PenRangeFilter,
): PenRangeFormValues {
  if (!values || !values.startPenId || !values.endPenId) {
    return {
      startPenId: null,
      endPenId: null,
      roundId: null,
      startPenData: null,
      endPenData: null,
    };
  }
  return {
    startPenId: values.startPenId || null,
    endPenId: values.endPenId || null,
    roundId: values.roundId || null,
    startPenData: null,
    endPenData: null,
  };
}

export function getPenRangeFilterIsActive(values: PenRangeFormValues): boolean {
  return Boolean(values && values.endPenId && values.startPenId);
}

export function getPenRangeFilterSetting(
  id: string,
  values: PenRangeFormValues,
): PenRangeFilter {
  return {
    type: FilterType.PenRange,
    id,
    startPenId: values.startPenId,
    endPenId: values.endPenId,
    roundId: values.roundId,
  };
}

export function getPenRangeValidationSchema(): any {
  return Yup.object()
    .nullable()
    .shape({
      startPenId: Yup.string().nullable().required("Required"),
      endPenId: Yup.string().nullable().required("Required"),
      roundId: Yup.number().nullable().required("Required"),
      startPenData: Yup.object().nullable(),
      endPenData: Yup.object().nullable(),
    });
}

export function applyFilter(
  filterSetting: PenRangeFilter,
  roundSellingPenIds: string[],
): string[] {
  const startIndex: number = roundSellingPenIds.indexOf(
    filterSetting.startPenId,
  );
  const endIndex: number = roundSellingPenIds.indexOf(filterSetting.endPenId);

  const firstPenIndex = Math.max(
    Math.min(startIndex, endIndex),
    0, // when start pen is not set, select the start of the list
  );
  let lastPenIndex = Math.max(startIndex, endIndex);
  if (lastPenIndex === -1) {
    // When last pen index is not set, select to the end of the list
    lastPenIndex = roundSellingPenIds.length - 1;
  }

  return roundSellingPenIds.slice(
    firstPenIndex,
    lastPenIndex + 1, // add 1 because `slice` end arg is exclusive
  );
}
